/**
 * Auth Drawer Component
 * Handles opening and closing the auth drawer
 */

if (!window.Eurus.loadedScript.has('auth-drawer.js')) {
  window.Eurus.loadedScript.add('auth-drawer.js');

  requestAnimationFrame(() => {
    window.addEventListener('alpine:init', () => {
      Alpine.data('authDrawer', () => ({
        drawerState: false,
        init() {
          this.registerEventListeners();
        },

        registerEventListeners() {
          window.addEventListener('eurus:auth:drawer-toggle', () => this.handleDrawerToggle());
        },

        isDrawerOpen() {
          return this.drawerState;
        },

        handleDrawerToggle() {
          if (this.isDrawerOpen()) {
            this.closeDrawer();
          } else {
            this.openDrawer();
          }
        },

        openDrawer() {
          this.drawerState = true;
          document.body.style.overflow = 'hidden';
        },

        closeDrawer() {
          this.drawerState = false;
          document.body.style.overflow = '';
        },
      }));
    });
  });
}
